/* tslint:disable */
import {
  Organization
} from '../index';

declare var Object: any;
export interface DonationCategoryInterface {
  "name": string;
  "image": string;
  "id"?: any;
  organizations?: Organization[];
}

export class DonationCategory implements DonationCategoryInterface {
  "name": string;
  "image": string;
  "id": any;
  organizations: Organization[];
  constructor(data?: DonationCategoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `DonationCategory`.
   */
  public static getModelName() {
    return "DonationCategory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of DonationCategory for dynamic purposes.
  **/
  public static factory(data: DonationCategoryInterface): DonationCategory{
    return new DonationCategory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'DonationCategory',
      plural: 'donation-categories',
      path: 'donation-categories',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "image": {
          name: 'image',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
        organizations: {
          name: 'organizations',
          type: 'Organization[]',
          model: 'Organization',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'donationCategoryId'
        },
      }
    }
  }
}
